import { render, staticRenderFns } from "./audit-container.vue?vue&type=template&id=0f5680c5"
import script from "./audit-container.vue?vue&type=script&lang=js"
export * from "./audit-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports